import React, { Fragment } from "react";
import DataTable from "../../../Datatable/DataTable";

const TableHolder = ({
  portfolio_growth_table_data,
  portfolio_growth_table_heading,
  HistMetricsLive,
}) => {
  return (
    <div className="mt-4">
      {portfolio_growth_table_data.length > 0 &&
      portfolio_growth_table_heading.length ===
        portfolio_growth_table_data[0].length ? (
        <Fragment>
          <DataTable
            data={portfolio_growth_table_data}
            columns={portfolio_growth_table_heading}
            paging={false}
            searching={false}
          />
          <br />
          {HistMetricsLive[0].type !== "BACKTEST" ? (
            <Fragment>
              <div>
                <small>
                  <b>*</b> &nbsp; 1 Month is calculated using last 30 day
                  (calendar) returns
                </small>
              </div>
              <div>
                <small>
                  <b>**</b> &nbsp; 3 Month is calculated using last 90 day
                  (calendar) returns
                </small>
              </div>
            </Fragment>
          ) : null}
        </Fragment>
      ) : null}
    </div>
  );
};
export default TableHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/portfolioGrowth/section2/tableHolder.jsx